import React from 'react'

const AdminFooter = () => {
    return (
        <div className="col-sm-12">
            <p> &copy; Devout { new Date().getFullYear()}</p>
        </div>
    )
}

export default AdminFooter
